export const TEXT = {
  en: {
    // ----- Language Dropdown -----
    langEnglish: "English",
    langFrench: "French",

    // ----- Login Page -----
    email: "Email address",
    password: "Password",
    signIn: "Sign in",
    signingIn: "Signing in...",
    forgot: "Forgot your password?",
    reset: "Reset Password",

    // ----- Confirm Email Page -----
    confirmEmailBtn: "Confirm Email",
    confirmEmailTitle: "Confirm your email",

    // ----- Validation Messages -----
    invalidEmail: "Invalid email address",
    emailRequired: "Email is required",
passwordRequired: "Password is required",
passwordMin: "Password must be at least 8 characters",
    // ----- API / Toast Messages -----
    resetSuccess: "Reset link sent successfully",
    resetError: "Something went wrong. Please try again",

    // ----- NEW Login Toasts -----
    loginSuccess: "Login Successful!",
    authFailed: "Authentication Failed!",
    somethingWrong: "Something went wrong!",
    invalidUserType: "Invalid User Type",
  },

  fr: {
    // ----- Language Dropdown -----
    langEnglish: "Anglais",
    langFrench: "Français",

    // ----- Login Page -----
    email: "Adresse e-mail",
    password: "Mot de passe",
    signIn: "Se connecter",
    signingIn: "Connexion...",
    forgot: "Mot de passe oublié ?",
    reset: "Réinitialiser le mot de passe",

    // ----- Confirm Email Page -----
    confirmEmailBtn: "Confirmer l'e-mail",
    confirmEmailTitle: "Confirmez votre e-mail",

    // ----- Validation Messages -----
    invalidEmail: "Adresse e-mail invalide",
    emailRequired: "L'e-mail est requis",
passwordRequired: "Le mot de passe est requis",
passwordMin: "Le mot de passe doit contenir au moins 8 caractères",
    // ----- API / Toast Messages -----
    resetSuccess: "Lien de réinitialisation envoyé avec succès",
    resetError: "Une erreur s'est produite. Veuillez réessayer",

    // ----- NEW Login Toasts -----
    loginSuccess: "Connexion réussie !",
    authFailed: "Échec de l'authentification !",
    somethingWrong: "Une erreur s'est produite !",
    invalidUserType: "Type d'utilisateur non valide",
  },
};
